var link_viewer_default = {
  "fontElementMap": "_8Dood",
  "link": "exdlk",
  "linkInEditor": "o-8uZ",
  "linkInViewer": "ovRxE",
  "toolbarUrlContainer": "_9p6k7",
  "toolbarUrl": "-fLRQ",
  "toolbarUrlAnchor": "ZWOSl"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
